<a
  routerLink="/"
  class="brand groove-ring"
  aria-label="Russ Rodgers Bass Guitar Instruction — home"
>
  <img
    class="brand-logo"
    src="/images/russlogo-112x112-black-bg.webp"
    alt="Russ Rodgers Bass Guitar Instruction"
    width="46"
    height="46"
  />
  <span class="brand-text">
    <span class="brand-name">Russ Rodgers</span>
    <span class="brand-sub">Bass Guitar Instruction</span>
  </span>
</a>
